import React from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../../store/indexStore";
import { getUniqueCategories } from "../../utils/UtilsFunctions";
import Iterator from "src/Components/utils/Iterator";
import { Button } from "src/Components/ui/button";
import { Plus, Package, Filter } from "lucide-react";
import AddItemsModel from "./AddItemsModel";
import {
  ProductCard,
  ProductCardLoading,
} from "src/Components/Cards/ProductCard";
import { Combobox } from "src/Components/selectbox/ComboBox";
import Visibility from "src/Components/utils/Visibility";
import { userTypes } from "src/enums/usersTpes";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";

function Items(props) {
  const {
    fetchItemsFunction,
    items,
    itemsLoading,
    nameLang,
    categories,
    setCategoryItemsOptionId,
    categoryItemsOptionId,
    menus,
  } = indexStore();
  const { t } = useTranslation();

  const onSelect = (value, option) => {
    fetchItemsFunction(value);
    setCategoryItemsOptionId(value);
  };

  const uniqueCategories = getUniqueCategories(categories, menus, nameLang);

  return (
    <div className="flex flex-col h-full gap-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <Package className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("dashbord.items")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_items_desc") || "Manage and organize your menu items"}
            </p>
          </div>
        </div>
        <Visibility
          visible={
            localStorage.getItem("role") === userTypes.ADMIN ||
            localStorage.getItem("role") === userTypes.DATAMANAGER
          }
        >
          <AddItemsModel
            trigger={
              <Button className="gap-2">
                <Plus className="w-4 h-4" />
                <span className="hidden md:block">
                  {t("gloabl.add")} {t("gloabl.item")}
                </span>
                <span className="md:hidden">{t("gloabl.add")}</span>
              </Button>
            }
          />
        </Visibility>
      </div>

      {/* Filter Card */}
      {uniqueCategories && uniqueCategories.length > 0 && (
        <Card className="border-2">
          <CardHeader className="pb-3 border-b">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-muted">
                <Filter className="w-5 h-5 text-muted-foreground" />
              </div>
              <div>
                <CardTitle className="text-lg">{t("gloabl.filter_items") || "Filter Items"}</CardTitle>
                <CardDescription>
                  {t("gloabl.filter_items_desc") || "Select a category to filter items"}
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-6">
            <Combobox
              data={uniqueCategories}
              onChange={onSelect}
              value={categoryItemsOptionId}
              placeholder={t("gloabl.select") + " " + t("gloabl.category")}
              lable={"displayName"}
            />
          </CardContent>
        </Card>
      )}

      {/* Items Grid */}
      <div className="flex-1">
        <Visibility visible={itemsLoading}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            <Iterator
              data={[1, 2, 3, 4]}
              render={(row) => <ProductCardLoading key={row} />}
            />
          </div>
        </Visibility>
        <Visibility visible={!itemsLoading}>
          {items.length > 0 ? (
            <>
              <div className="mb-4 text-sm text-muted-foreground">
                {t("gloabl.items_found", { count: items.length }) || `${items.length} ${t("gloabl.item")}${items.length > 1 ? "s" : ""}`}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                <Iterator data={items} render={(row) => <ProductCard key={row.id} {...row} />} />
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
              <Package className="w-16 h-16 mb-4 text-gray-300" />
              <p className="text-xl font-semibold mb-2">{t("gloabl.no_items_found") || "No items found"}</p>
              <p className="mb-4">
                {categoryItemsOptionId
                  ? t("gloabl.no_items_in_category") || "No items in this category"
                  : t("gloabl.items_will_appear") || "Items will appear here once you add them"}
              </p>
              <Visibility
                visible={
                  localStorage.getItem("role") === userTypes.ADMIN ||
                  localStorage.getItem("role") === userTypes.DATAMANAGER
                }
              >
                <AddItemsModel
                  trigger={
                    <Button variant="outline" className="gap-2">
                      <Plus className="w-4 h-4" />
                      {t("gloabl.add")} {t("gloabl.item")}
                    </Button>
                  }
                />
              </Visibility>
            </div>
          )}
        </Visibility>
      </div>
    </div>
  );
}

export default Items;
